<template>
  <base-button type="submit" class="btn-primary" text="申請" />
</template>

<script>
import BaseButton from '@/views/atoms/BaseButton';

export default {
  name: 'ApplicationButton',
  components: {
    BaseButton,
  },
}
</script>
